'use client';

import { c as _c } from "react/compiler-runtime";
import { getAriaLabel } from '@bridge/utils';
import { useFormContext } from 'react-hook-form';
import { MultipleSelector } from '../../components';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { FormOption } from '../../types';
import type { BaseFieldProps } from './types';
import type { FieldComponentWithOptions } from './utils';
export type MultipleSelectorComponentProps = FieldComponentWithOptions<typeof MultipleSelector, FormOption>;
interface MultipleSelectorFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: MultipleSelectorComponentProps;
}
export function MultipleSelectorField(t0) {
  const $ = _c(45);
  const {
    field,
    fieldConfig,
    fieldState,
    componentProps,
    labelSize
  } = t0;
  let componentDisabled;
  let creatable;
  let id;
  let optionsProp;
  let restComponentProps;
  if ($[0] !== componentProps) {
    ({
      options: optionsProp,
      id,
      disabled: componentDisabled,
      creatable,
      ...restComponentProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = componentDisabled;
    $[2] = creatable;
    $[3] = id;
    $[4] = optionsProp;
    $[5] = restComponentProps;
  } else {
    componentDisabled = $[1];
    creatable = $[2];
    id = $[3];
    optionsProp = $[4];
    restComponentProps = $[5];
  }
  const isDisabled = field.disabled || componentDisabled;
  let t1;
  if ($[6] !== fieldConfig || $[7] !== fieldState || $[8] !== id) {
    t1 = getFieldIds(fieldConfig, fieldState, id);
    $[6] = fieldConfig;
    $[7] = fieldState;
    $[8] = id;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const ids = t1;
  const formContext = useFormContext();
  let t2;
  if ($[10] !== formContext || $[11] !== optionsProp) {
    t2 = typeof optionsProp === "function" ? optionsProp(formContext) : optionsProp;
    $[10] = formContext;
    $[11] = optionsProp;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const options = t2;
  let t3;
  if ($[13] !== field) {
    t3 = options_0 => {
      field.onChange(options_0.map(_temp));
    };
    $[13] = field;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const handleChange = t3;
  let t4;
  if ($[15] !== creatable || $[16] !== field.value || $[17] !== options) {
    let t5;
    if ($[19] !== creatable || $[20] !== options) {
      t5 = value => {
        const existingOption = options.find(option_0 => option_0.value === value);
        if (existingOption) {
          return existingOption;
        }
        if (creatable) {
          return {
            label: value,
            value
          } as FormOption;
        }
        return null;
      };
      $[19] = creatable;
      $[20] = options;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    t4 = (field.value || []).map(t5).filter(Boolean);
    $[15] = creatable;
    $[16] = field.value;
    $[17] = options;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const selectedOptions = t4 as FormOption[];
  const t5 = ids.fieldId;
  let t6;
  if ($[22] !== fieldConfig.label) {
    t6 = getAriaLabel(fieldConfig.label);
    $[22] = fieldConfig.label;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== ids.describedBy || $[25] !== ids.fieldId || $[26] !== ids.isInvalid || $[27] !== restComponentProps.inputProps || $[28] !== t6) {
    t7 = {
      id: t5,
      "aria-label": t6,
      "aria-invalid": ids.isInvalid,
      "aria-describedby": ids.describedBy,
      ...restComponentProps.inputProps
    };
    $[24] = ids.describedBy;
    $[25] = ids.fieldId;
    $[26] = ids.isInvalid;
    $[27] = restComponentProps.inputProps;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  const t8 = restComponentProps.placeholder || "Select options...";
  let t9;
  if ($[30] !== creatable || $[31] !== handleChange || $[32] !== isDisabled || $[33] !== options || $[34] !== restComponentProps || $[35] !== selectedOptions || $[36] !== t7 || $[37] !== t8) {
    t9 = <MultipleSelector {...restComponentProps} creatable={creatable} disabled={isDisabled} inputProps={t7} onChange={handleChange} options={options} placeholder={t8} value={selectedOptions} />;
    $[30] = creatable;
    $[31] = handleChange;
    $[32] = isDisabled;
    $[33] = options;
    $[34] = restComponentProps;
    $[35] = selectedOptions;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== fieldConfig || $[40] !== fieldState || $[41] !== ids || $[42] !== labelSize || $[43] !== t9) {
    t10 = <FieldShell fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t9}</FieldShell>;
    $[39] = fieldConfig;
    $[40] = fieldState;
    $[41] = ids;
    $[42] = labelSize;
    $[43] = t9;
    $[44] = t10;
  } else {
    t10 = $[44];
  }
  return t10;
}
function _temp(option) {
  return option.value;
}